// switches the main image and clicked thumbnail image
const handleGalleryThumbnailClick = (event, modalContentSetterFn, currentModalItemIndex, mainImgSrc) => {
	const src = event.target.src;
	const imgId = parseInt(event.target.dataset.id);
	if (!src) return;
	modalContentSetterFn(prevContent => {
		const newContent = {
			image: {...prevContent.image, url: src},
			gallery: prevContent[currentModalItemIndex].gallery.map((galleryImg) => {
				if (galleryImg.id !== imgId) {
					return galleryImg;
				}
				if (galleryImg.id === imgId) {
					return {...galleryImg, image: mainImgSrc};
				}
			})
		}
		const newContentObj = {...prevContent[currentModalItemIndex], ...newContent};
		const prevContentCopy = [...prevContent];
		prevContentCopy[currentModalItemIndex] = newContentObj;
		return prevContentCopy;
	});
}

export default handleGalleryThumbnailClick;